import { CreateMarker } from "./CreateMarker";
import { Filter } from "./Filter";

export class SitePlan {
  stage = document.getElementById('stage');
  map   = document.getElementById('map');
  img   = document.getElementById('mapImg');
  mini  = document.getElementById('mini');
  view  = document.getElementById('viewport');
  arrowLeft  = document.querySelector('.minimap__arrow-left');
  arrowRight = document.querySelector('.minimap__arrow-right');

  marker = [];
  state = { x: 0, dragging: false, lastX: 0, stageW: 0, mapW: 0, pointerId: -1, clickedOnMarker: false, hasMoved: false };
  viewState = { dragging: false, lastX: 0, pointerId: -1 };
  miniState = { dragging: false, startX: 0, startMapX: 0, pointerId: -1 };
  arrowState = { left: false, right: false, intervalId: null };

  // Modifier-Status
  isAlt = false;
  isCtrl = false;

  constructor() {
    this.init();



    document.addEventListener('click', (e) => { 
        if (CreateMarker.openWindow) {
        CreateMarker.openWindow.style.display = 'none';
        CreateMarker.openWindow = null;
      }
    });
  }

  init() {


    this.stage.style.touchAction = 'pan-y';
    this.stage.style.userSelect = 'none';
    this.img.draggable = false;
    this.view.style.cursor = 'grab';
    this.view.style.touchAction = 'pan-y';

    // Handler binden
    this.onPointerDown = this._onPointerDown.bind(this);
    this.onPointerMove = this._onPointerMove.bind(this);
    this.onPointerUp   = this._onPointerUp.bind(this);
    this.onMapClick    = this._onMapClick.bind(this);
    this.onKeyDown     = this._onKeyDown.bind(this);
    this.onKeyUp       = this._onKeyUp.bind(this);
    this.resize        = this._resize.bind(this);
    this.onViewPointerDown = this._onViewPointerDown.bind(this);
    this.onMiniPointerDown = this._onMiniPointerDown.bind(this);
    this.onArrowLeftDown = this._onArrowLeftDown.bind(this);
    this.onArrowLeftUp = this._onArrowLeftUp.bind(this);
    this.onArrowRightDown = this._onArrowRightDown.bind(this);
    this.onArrowRightUp = this._onArrowRightUp.bind(this);

    // Pointer-Events
    this.stage.addEventListener('pointerdown', this.onPointerDown, { passive: false });
    // pointermove und pointerup auf document, damit auch außerhalb der Stage erfasst wird
    document.addEventListener('pointermove', this.onPointerMove, { passive: false });
    document.addEventListener('pointerup',   this.onPointerUp);
    document.addEventListener('pointercancel', this.onPointerUp);

    // Klick zum Messen (Alt+Strg)
    this.stage.addEventListener('click', this.onMapClick, { passive: false });

    // Key-Listener für Cursor/Fadenkreuz
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('keyup', this.onKeyUp);

    // Mini-Map - pointerdown für sofortige Reaktion bei Touch und Click
    this.mini.addEventListener('pointerdown', this.onMiniPointerDown, { passive: false });
    this.mini.style.touchAction = 'pan-y';

    // Viewport Dragging
    this.view.addEventListener('pointerdown', this.onViewPointerDown, { passive: false });

    // Arrow-Buttons mit pointerdown/pointerup für kontinuierliches Bewegen bei gedrückt halten
    if (this.arrowLeft) {
      this.arrowLeft.addEventListener('pointerdown', this.onArrowLeftDown);
      this.arrowLeft.addEventListener('pointerup', this.onArrowLeftUp);
      this.arrowLeft.addEventListener('pointercancel', this.onArrowLeftUp);
      this.arrowLeft.addEventListener('pointerleave', this.onArrowLeftUp);
      this.arrowLeft.addEventListener('mouseleave', this.onArrowLeftUp); // Fallback für Maus
      this.arrowLeft.style.touchAction = 'manipulation';
    }

    if (this.arrowRight) {
      this.arrowRight.addEventListener('pointerdown', this.onArrowRightDown);
      this.arrowRight.addEventListener('pointerup', this.onArrowRightUp);
      this.arrowRight.addEventListener('pointercancel', this.onArrowRightUp);
      this.arrowRight.addEventListener('pointerleave', this.onArrowRightUp);
      this.arrowRight.addEventListener('mouseleave', this.onArrowRightUp); // Fallback für Maus
      this.arrowRight.style.touchAction = 'manipulation';
    }

    // Resize / initiales Layout
    this.img.onload = this.resize;
    window.addEventListener('resize', this.resize);
    this.resize();
    this.update();
  }

  setMarker(markers) {
    markers.sort((a, b) => {
      const ay = a.cords.y;
      const by = b.cords.y;
      const ax = a.cords.x;
      const bx = b.cords.x;
  
      const yDiff = ay - by; // positiv wenn a weiter unten ist
  
      // nur wenn die Zeilen wirklich weit auseinander liegen (> 8),
      // entscheidet y (kleiner y zuerst)
      if (Math.abs(yDiff) > 8) {
        return yDiff; // y aufsteigend
      }
  
      // sonst gleiche "visuelle" Zeile → nach x sortieren (kleiner x zuerst)
      return ax - bx;
    });
    


    markers.forEach(marker => {
      this.marker.push(this.map.appendChild(CreateMarker.create(marker, this.map, this.stage)));
    });
    const filter = new Filter();
  }

  // ----- Helper -----
  updateCursor() {
    this.stage.style.cursor = (this.isAlt && this.isCtrl) ? 'crosshair' : '';
  }

  // ----- Events -----
  _onKeyDown(e) {
    if (e.key === 'Alt') this.isAlt = true;
    if (e.key === 'Control' || e.key === 'Meta') this.isCtrl = true;
    this.updateCursor();
  }


  _onKeyUp(e) { 
    if (e.key === 'Alt') this.isAlt = false;
    if (e.key === 'Control' || e.key === 'Meta') this.isCtrl = false;
    this.updateCursor();
  }

  _onMapClick(e) {
    // Nur messen, wenn Alt+Strg aktiv und nicht auf Marker
    if (!(this.isAlt && this.isCtrl)) return;
    if (e.target && e.target.closest && e.target.closest('.marker')) return;

    const rect = this.img.getBoundingClientRect(); // reale Größe/Position
    const relX = (e.clientX - rect.left) / rect.width;
    const relY = (e.clientY - rect.top) / rect.height;

    const x = Math.min(1, Math.max(0, relX));
    const y = Math.min(1, Math.max(0, relY));

    const xPct = (x * 100).toFixed(2);
    const yPct = (y * 100).toFixed(2);

    console.log(`Position: x=${xPct}%, y=${yPct}%`);
  }

  _onPointerDown(e) {
    // Wenn Alt+Strg aktiv → kein Drag, nur messen
    if (this.isAlt && this.isCtrl) return;
    
    // Merke, ob auf Marker geklickt wurde - aber starte trotzdem Dragging für Drag über Marker
    this.state.clickedOnMarker = false;
    this.state.hasMoved = false;
    if (e.target && (e.target.closest('.marker') || e.target.classList.contains('marker'))) {
      this.state.clickedOnMarker = true;
    }
    
    // Kein preventDefault hier, damit Marker-Klicks funktionieren
    // preventDefault wird erst im pointermove aufgerufen
     
    this.state.dragging = true;
    this.state.lastX = e.clientX;
    this.state.pointerId = e.pointerId;
    // setPointerCapture nur bei Touch-Events, um Desktop-Klicks nicht zu blockieren
    if (e.pointerType === 'touch') {
      try {
        this.stage.setPointerCapture(e.pointerId);
      } catch (err) {
        // Fallback falls setPointerCapture nicht unterstützt wird
      }
    }
    this.stage.classList.add('dragging');
  }

  _onPointerMove(e) {
    // Viewport-Dragging hat Priorität
    if (this.viewState.dragging) {
      e.preventDefault();
      const dx = e.clientX - this.viewState.lastX;
      this.viewState.lastX = e.clientX;
      
      // dx in Mini-Map-Pixel → in Map-Position umrechnen
      const miniWidth = this.mini.clientWidth;
      const ratio = this.state.mapW / miniWidth;
      
      // Negatives Vorzeichen, weil die Map-Position invertiert zur Viewport-Bewegung ist
      this.state.x = this.clampX(this.state.x - dx * ratio);
      this.update();
      return;
    }
    
    // Mini-Map-Dragging
    if (this.miniState.dragging) {
      e.preventDefault();
      const rect = this.mini.getBoundingClientRect();
      const rx = (e.clientX - rect.left) / rect.width;
      this.state.x = this.clampX(-rx * this.state.mapW + this.state.stageW / 2);
      this.update();
      return;
    }
    
    // Map-Dragging
    if (!this.state.dragging) return;
    
    // Prüfe, ob tatsächlich Bewegung stattgefunden hat (mindestens 5px für Drag)
    const dx = Math.abs(e.clientX - this.state.lastX);
    if (dx > 5) {
      this.state.hasMoved = true;
    }
    
    // Wenn auf Marker geklickt wurde, aber Bewegung stattgefunden hat, dann ist es ein Drag
    if (this.state.hasMoved) {
      e.preventDefault();
      this.state.x = this.clampX(this.state.x + (e.clientX - this.state.lastX));
      this.state.lastX = e.clientX;
      this.update();
    }
  }

  _onPointerUp(e) {
    // Viewport-Dragging beenden
    if (this.viewState.dragging && this.viewState.pointerId !== -1) {
      // Pointer-Capture freigeben, falls gesetzt
      if (this.view.hasPointerCapture(this.viewState.pointerId)) {
        this.view.releasePointerCapture(this.viewState.pointerId);
      }
      this.viewState.dragging = false;
      this.viewState.pointerId = -1;
      this.view.style.cursor = 'grab';
    }
    
    // Mini-Map-Dragging beenden
    if (this.miniState.dragging && this.miniState.pointerId !== -1) {
      // Pointer-Capture freigeben, falls gesetzt
      if (this.mini.hasPointerCapture(this.miniState.pointerId)) {
        this.mini.releasePointerCapture(this.miniState.pointerId);
      }
      this.miniState.dragging = false;
      this.miniState.pointerId = -1;
    }
    
    // Map-Dragging beenden
    if (this.state.dragging && this.state.pointerId !== -1) {
      // Pointer-Capture freigeben, falls gesetzt
      if (this.stage.hasPointerCapture(this.state.pointerId)) {
        this.stage.releasePointerCapture(this.state.pointerId);
      }
      
      // Wenn auf Marker geklickt wurde, aber Bewegung stattgefunden hat, verhindere Click-Event
      // Wenn keine Bewegung stattgefunden hat, lasse Click-Event durch für Info-Window
      if (this.state.clickedOnMarker && this.state.hasMoved) {
        e.preventDefault();
      }
    }
    
    // Reset States
    this.state.dragging = false;
    this.state.pointerId = -1;
    this.state.clickedOnMarker = false;
    this.state.hasMoved = false;
    this.stage.classList.remove('dragging');
  }

  update() {
    // Nur updaten, wenn die Werte initialisiert sind
    if (this.state.stageW === 0 || this.state.mapW === 0) {
      return;
    }
    
    this.map.style.transform = `translate3d(${this.state.x}px, 0, 0)`;
    const ratio = this.state.stageW / this.state.mapW;
    this.view.style.width = (ratio * this.mini.clientWidth) + 'px';
    const rel = -this.state.x / this.state.mapW;
    this.view.style.left = (rel * this.mini.clientWidth) + 'px';
  }

  clampX(x) {
    // Sicherstellen, dass Werte initialisiert sind
    if (this.state.stageW === 0 || this.state.mapW === 0) {
      return x;
    }
    const max = 0;
    const min = this.state.stageW - this.state.mapW;
    return Math.min(max, Math.max(min, x));
  }

  _resize() {
    // Warten, bis das Bild vollständig geladen ist
    if (!this.img.naturalWidth || !this.img.naturalHeight) {
      return;
    }
    
    this.state.stageW = this.stage.clientWidth;
    const stageH = this.stage.clientHeight;
    const scale = stageH / this.img.naturalHeight;
    this.state.mapW = this.img.naturalWidth * scale;

    this.img.style.width = this.state.mapW + 'px';
    this.img.style.height = stageH + 'px';

    this.state.x = this.clampX(this.state.x);
    this.update();
  }

  // ----- Viewport Dragging -----
  _onViewPointerDown(e) {
    e.preventDefault();
    e.stopPropagation(); // verhindert, dass das Click-Event auf mini ausgelöst wird
    this.viewState.dragging = true;
    this.viewState.lastX = e.clientX;
    this.viewState.pointerId = e.pointerId;
    this.view.setPointerCapture(e.pointerId);
    this.view.style.cursor = 'grabbing';
  }

  // ----- Mini-Map Dragging -----
  _onMiniPointerDown(e) {
    // Kein Springen wenn auf dem Viewport geklickt wurde
    if (e.target === this.view) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    // Sofort zur Position springen (ohne Transition)
    const rect = this.mini.getBoundingClientRect();
    const rx = (e.clientX - rect.left) / rect.width;
    this.state.x = this.clampX(-rx * this.state.mapW + this.state.stageW / 2);
    this.update();
    
    // Dragging starten für sofortiges Follow
    this.miniState.dragging = true;
    this.miniState.startX = e.clientX;
    this.miniState.startMapX = this.state.x;
    this.miniState.pointerId = e.pointerId;
    
    try {
      this.mini.setPointerCapture(e.pointerId);
    } catch (err) {
      // Fallback falls setPointerCapture nicht unterstützt wird
    }
  }

  // ----- Arrow Buttons -----
  _stopArrowMovement() {
    if (this.arrowState.intervalId !== null) {
      clearInterval(this.arrowState.intervalId);
      this.arrowState.intervalId = null;
    }
    this.arrowState.left = false;
    this.arrowState.right = false;
  }

  _startArrowMovement() {
    // Stoppe vorhandenes Intervall falls vorhanden
    if (this.arrowState.intervalId !== null) {
      clearInterval(this.arrowState.intervalId);
      this.arrowState.intervalId = null;
    }
    
    // Prüfe welche Richtung aktiv ist
    if (!this.arrowState.left && !this.arrowState.right) {
      return;
    }

    // Kontinuierliche Bewegung ohne Transition
    this.arrowState.intervalId = setInterval(() => {
      if (this.arrowState.left) {
        this.state.x = this.clampX(this.state.x + 18);
        this.update();
      }
      if (this.arrowState.right) {
        this.state.x = this.clampX(this.state.x - 18);
        this.update();
      }
    }, 16); // ~60fps für smooth Bewegung
  }

  _onArrowLeftDown(e) {
    e.preventDefault();
    e.stopPropagation();
    this.arrowState.left = true;
    this._startArrowMovement();
  }

  _onArrowLeftUp(e) {
    e.preventDefault();
    e.stopPropagation();
    this.arrowState.left = false;
    if (!this.arrowState.right) {
      this._stopArrowMovement();
    } else {
      this._startArrowMovement();
    }
  }

  _onArrowRightDown(e) {
    e.preventDefault();
    e.stopPropagation();
    this.arrowState.right = true;
    this._startArrowMovement();
  }

  _onArrowRightUp(e) {
    e.preventDefault();
    e.stopPropagation();
    this.arrowState.right = false;
    if (!this.arrowState.left) {
      this._stopArrowMovement();
    } else {
      this._startArrowMovement();
    }
  }
}
